import MemberLogRequest from "../requests/MemberLogRequest";
import api from "./axios";


export class LoggingService {
    async logPageView(memberLogRequest: MemberLogRequest) {
        try {
            await api.post(
                "/logging/page-view",
                memberLogRequest
            );

        } catch (error) {
        
            throw new Error("error logging page");
        }
    }
}

export default new LoggingService();